import { KdsModal, KdsText, VStack } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useState } from "react";

import { DeliverySummaryTableVersions } from "./DeliverySummaryTableVersions";
import { type ManualDispatchSummaryProps } from "./ManualDispatchSummary.types";

export const ManualDispatchSummary = ({
  orderItem,
}: ManualDispatchSummaryProps) => {
  const { t } = useTranslate();

  // States
  const [
    isModalExpandedTableVersionsOpen,
    setIsModalExpandedTableVersionsOpen,
  ] = useState(false);

  return (
    <VStack gap="sp-xl">
      <KdsText size="subtitle-sm">
        {t(
          "order.catalogMediumConfiguration.stepDelivery.addressBlock.title_plural"
        )}
      </KdsText>

      <DeliverySummaryTableVersions
        orderItem={orderItem}
        onTableVersionExpand={() =>
          setIsModalExpandedTableVersionsOpen(!isModalExpandedTableVersionsOpen)
        }
      />

      <KdsModal
        isOpen={isModalExpandedTableVersionsOpen}
        dialogProps={{
          dialogHeaderProps: {
            title: t("orderItemConfig.modal.expandedTableVersions.title"),
          },
          content: <DeliverySummaryTableVersions orderItem={orderItem} />,
          dialogFooterProps: {
            buttonProps: [
              {
                children: t("buttons.close"),
                color: "neutral",
                variant: "outlined",
                onPress: () => setIsModalExpandedTableVersionsOpen(false),
              },
            ],
          },
        }}
        onOpenChange={() => setIsModalExpandedTableVersionsOpen(false)}
      />
    </VStack>
  );
};
